<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">{{ dataVal.title }}</div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="posi-over">
        <el-transfer
          filterable
          filter-placeholder="请输入城市"
          :titles="['所有城市', '已选城市']"
          v-model="value"
          :data="city"
        >
        </el-transfer>
      </div>

      <div class="posi-btn">
        <div class="hui" @click="handleClose">{{ dataVal.btn2 || "取消" }}</div>
        <div @click="handleSubmit">{{ dataVal.btn1 || "确认" }}</div>
      </div>
    </div>
  </div>
</template>
      <script>
export default {
  name: "FillIn",
  props: ["dataVal"],
  data() {
    return {
      value: [],
      city: [],
    };
  },
  mounted() {},
  methods: {
    //得到开通城市
    async fenxiaoGetopencity() {
      let res = await this.$api.fenxiaoGetopencity();
      if (res.code == 1) {
        let value = [];
        res.data.forEach((item, index) => {
          value.push(item.id);
        });
        this.value = value;
      }
    },
    //得到所有城市
    async indexGetcity() {
      let res = await this.$api.indexGetcity();
      if (res.code == 1) {
        let city = [];
        res.data.forEach((item, index) => {
          city.push({
            label: item.name,
            key: item.id,
          });
        });
        this.city = city;
      }
    },
    //提交
    async handleSubmit() {
      let res = await this.$api.fenxiaoOpencity({
        ids: this.value.toString(),
      });
      if (res.code == 1) {
        this.$message.success("开通成功");
        let obj = {
          flag: false,
          submitFlag: true,
        };
        this.$emit("addressCell", obj);
      }
    },
    //关闭
    handleClose() {
      let obj = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("addressCell", obj);
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        if (newVal.flag) {
          this.fenxiaoGetopencity();
          this.indexGetcity();
        }
      },
      deep: true,
    },
  },
};
</script>
      <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}
.posi-center {
  width: 1016px;
  height: 75vh;
  border-radius: 25px;
  background-color: #fff;
  overflow: hidden;
  .posi-head {
    height: 70px;
    padding: 0 36px 0 32px;
    background-color: #f2f6ff;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 20px;
      color: #aeaeb2;
      cursor: pointer;
    }
  }
  /deep/.posi-over {
    height: 54vh;
    overflow: auto;
    padding: 15px 0 0;
    .el-transfer {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-transfer__buttons {
        display: flex;
        flex-direction: column;
        .el-button + .el-button,
        .el-checkbox.is-bordered + .el-checkbox.is-bordered {
          margin-left: 0;
        }
        .el-transfer__button {
          width: 32px;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0;
          border-radius: 50%;
          background-color: $y-color;
          border-color: $y-color;
          color: #fff;
        }
        .el-button--primary.is-disabled,
        .el-button--primary.is-disabled:active,
        .el-button--primary.is-disabled:focus,
        .el-button--primary.is-disabled:hover {
          background-color: #f7f8fa;
          border-color: #f7f8fa;
          color: #c9cdd4;
        }
      }
      .el-transfer-panel {
        height: 100%;
        width: 37%;
        .el-transfer-panel__body {
          height: 100%;
          .el-transfer-panel__list.is-filterable {
            height: 100%;
          }
        }
      }
    }
  }
  .posi-btn {
    padding-top: 40px;
    @include flex-center(center, center);
    div {
      width: 100px;
      height: 35px;
      background-color: #007aff;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      @include flex-center(center, center);

      cursor: pointer;
    }
    .hui {
      margin-right: 42px;
      background-color: #f5f5f5;
      color: #363636;
    }
  }
}
</style>